import { BUILDING_TYPE_LABELS } from 'shared/constants/buildingLabels';
import type { IBuildingCard } from 'shared/types/buildingCard';

/** Заголовок секции описания: «Про бизнес-центр» */
export function getDescriptionTitle(card: IBuildingCard): string | null {
  const label = card.buildingType ? BUILDING_TYPE_LABELS[card.buildingType] : undefined;

  return label ? `Про ${label.toLowerCase()}` : null;
}
